module.exports = __webpack_public_path__ + "static/media/porco.57a8eb6a.jpg";